module.exports = __webpack_public_path__ + "img/ic_checkin_member.e9c631dc.png";